import { postRequest } from "../apiHelpers";
import {
	getAllMember, deleteMemberById, getMemberById, findMember, editMember,
	changePassword, getDeviceNotification, addDeviceNotification, deleteDeviceNotification,
	getDashboard
} from "../pathApi";
import { createAsyncThunk } from "@reduxjs/toolkit";


export const callEditMember = createAsyncThunk(editMember, async (body) => {
	try {
		const response = await postRequest({ url: editMember, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callFindMember = createAsyncThunk(findMember, async (body) => {
	try {
		const response = await postRequest({ url: findMember, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetAllMember = createAsyncThunk(getAllMember, async (body) => {
	try {
		const response = await postRequest({ url: getAllMember, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetMemberById = createAsyncThunk(getMemberById, async (body) => {
	try {
		const response = await postRequest({ url: getMemberById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callDeleteMemberById = createAsyncThunk(deleteMemberById, async (body) => {
	try {
		const response = await postRequest({ url: deleteMemberById, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callChangePassword = createAsyncThunk(changePassword, async (body) => {
	try {
		const response = await postRequest({ url: changePassword, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callGetDeviceNotification = createAsyncThunk(getDeviceNotification, async (body) => {
	try {
		const response = await postRequest({ url: getDeviceNotification, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callAddDeviceNotification = createAsyncThunk(addDeviceNotification, async (body) => {
	try {
		const response = await postRequest({ url: addDeviceNotification, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callDeleteDeviceNotification = createAsyncThunk(deleteDeviceNotification, async (body) => {
	try {
		const response = await postRequest({ url: deleteDeviceNotification, data: body });
		return response;
	} catch (error) {
		throw error
	}
});

export const callDashboard = createAsyncThunk(getDashboard, async (body) => {
	try {
		const response = await postRequest({ url: getDashboard, data: body });
		return response;
	} catch (error) {
		throw error
	}
});